<template>
<div>
    <!-- <div class="container">
        <h2>よくあるお問い合わせ</h2>
        <div>※お手数ですが最下部にて横スクロールして回答をお読みください。</div>
        <div>※こちらで解決できない問題がありましたらお問い合わせいただけますでしょうか。</div>
  <table width="1170px" style="width: 1170px;" class="inquiryTable">
    <colgroup>
      <col style="width: 56px;">
      <col style="width: 254px;">
      <col style="width: 860px;">
    </colgroup>
    <tbody>
      <tr>
        <td style="vertical-align: middle; background-color: rgb(0, 129, 194); border-color: rgb(0, 103, 155);">
          <div><span style="font-size: 14px; color: rgb(255, 255, 255); font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;"> No.</span></div>
        </td>
        <td style="background-color: rgb(0, 129, 194); border-color: rgb(0, 103, 155);">
          <div><span style="font-size: 14px; color: rgb(255, 255, 255); font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">&nbsp; &nbsp; &nbsp; &nbsp; お問い合わせ</span></div>
        </td>
        <td style="background-color: rgb(0, 129, 194); border-color: rgb(0, 103, 155);">
          <div><span style="font-size: 14px; color: rgb(255, 255, 255); font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">回答</span></div>
        </td>
      </tr>
      <tr>
        <td style="vertical-align: middle; border-color: rgb(204, 204, 204);">
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">１</span></div>
        </td>
        <td style="vertical-align: middle; border-color: rgb(204, 204, 204);">
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">出品されない</span></div>
        </td>
        <td style="border-color: rgb(204, 204, 204);">
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">①在庫数が１以上設定されているか</span></div>
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">　→在庫数が０の場合は出品されません。</span></div>
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">②「出品登録一覧」画面で商品が登録されているか。</span></div>
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">③「ユーザー管理」画面のログイン確認欄にチェックが入っているか</span></div>
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">　→チェックが入っていない場合、No.２をご確認ください。</span></div>
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">上記３点が正しく設定されている場合は、お問い合わせいただけますでしょうか。システムの不具合の可能性がありますので原因を調査致します。</span></div>
        </td>
      </tr>
      <tr>
        <td style="vertical-align: middle; border-color: rgb(204, 204, 204);">
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">２</span></div>
        </td>
        <td style="vertical-align: middle; border-color: rgb(204, 204, 204);">
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">ログイン確認欄にチェックが入っていない</span></div>
        </td>
        <td style="border-color: rgb(204, 204, 204);">
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">①販売媒体（メルカリ等）の本人確認が完了しているか</span></div>
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">　→本人確認が完了していない販売媒体はシステム接続ができません。</span></div>
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">②ブラウザで販売媒体（メルカリ等）がログアウトされているか</span></div>
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">　→月に１～２回程度強制的にログアウトされます。ログイン設定ファイルの再取得が必要です。</span></div>
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">　　<a href="https://youtu.be/zZQuSgPFoHQ" rev="en_rl_none" style="font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold; font-size: 12px;">https://youtu.be/zZQuSgPFoHQ</a></span></div>
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">上記２点が正しく設定されている場合は、お問い合わせいただけますでしょうか。システムの不具合の可能性がありますので原因を調査致します。</span></div>
        </td>
      </tr>
      <tr>
        <td style="vertical-align: middle; border-color: rgb(204, 204, 204);">
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">３</span></div>
        </td>
        <td style="vertical-align: middle; border-color: rgb(204, 204, 204);">
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">出品が途中で止まっている</span></div>
        </td>
        <td style="border-color: rgb(204, 204, 204);">
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">出品時刻、出品間隔をご確認ください。</span></div>
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">システムの設定処理で毎日朝の５時にシステムが一度停止します。その時間まで出品が続くような出品時刻、出品間隔を設定している場合はそのタイミングで出品が止まります。出品時刻や出品間隔の設定を変更してください。</span></div>
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">上記に該当しない場合はお問い合わせいただけますでしょうか。システムの不具合の可能性がありますので原因を調査致します。</span></div>
        </td>
      </tr>
      <tr>
        <td style="vertical-align: middle; border-color: rgb(204, 204, 204);">
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">４</span></div>
        </td>
        <td style="vertical-align: middle; border-color: rgb(204, 204, 204);">
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">出品登録したが出品されない</span></div>
        </td>
        <td style="border-color: rgb(204, 204, 204);">
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">「出品登録一覧」画面での登録操作は、あくまでどのアカウントでどの商品を出品するかを決定する操作です。登録をしたら出品されるわけではありません。</span></div>
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">「ユーザー管理」画面にあります、出品時刻、値引時刻、出品間隔を設定して登録することで、その時間に出品がされる仕組みとなっております。</span></div>
        </td>
      </tr>
      <tr>
        <td style="border-color: rgb(204, 204, 204);">
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">５</span></div>
        </td>
        <td style="border-color: rgb(204, 204, 204);">
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">出品登録したアカウントと違うアカウントの販売媒体に出品されている</span></div>
        </td>
        <td style="border-color: rgb(204, 204, 204);">
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">ログイン設定ファイルの読み込み方に誤りがある可能性があります。</span></div>
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">「ユーザー管理」画面のログイン設定ファイルを選択する際に、別のアカウントのログイン設定ファイルを選択してしまうとそのアカウントの販売媒体に出品されてしまします。</span></div>
          <div><br></div>
        </td>
      </tr>
      <tr>
        <td style="vertical-align: middle; border-color: rgb(204, 204, 204);">
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">６</span></div>
        </td>
        <td style="vertical-align: middle; border-color: rgb(204, 204, 204);">
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">１日の出品上限数</span></div>
        </td>
        <td style="border-color: rgb(204, 204, 204);">
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">販売媒体の評価数に応じて検討してください。</span></div>
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">以下、目安</span></div>
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">０～５０評価：１５-２０商品</span></div>
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">５１～７０評価：２０-２５商品</span></div>
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">１００評価：３０商品</span></div>
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">以下の動画でも説明があります。(2:30あたり)</span></div>
          <div><span style="font-size: 12px;"><a href="https://youtu.be/wxOcrjT_ZCE" style="font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold; font-size: 12px; text-decoration: underline;">https://youtu.be/wxOcrjT_ZCE</a></span></div>
        </td>
      </tr>
      <tr>
        <td style="vertical-align: middle; border-color: rgb(204, 204, 204);">
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">７</span></div>
        </td>
        <td style="vertical-align: middle; border-color: rgb(204, 204, 204);">
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">他の販売媒体もシステムに接続できるか</span></div>
        </td>
        <td style="border-color: rgb(204, 204, 204);">
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">ログイン設定ファイルの再取得が必要です。</span></div>
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">既に接続している販売媒体と新たに接続したい販売媒体、全てログインした状態での取得をお願い致します。</span></div>
          <div><span style="font-size: 12px;"><a href="https://youtu.be/zZQuSgPFoHQ" rev="en_rl_none" style="font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold; font-size: 12px;">https://youtu.be/zZQuSgPFoHQ</a></span></div>
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;"><span style="font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold; font-size: 12px; color: rgb(252, 18, 51);">注</span>：ログイン設定ファイルのシステム読み込みが反映されるのは翌日になりますのご注意ください。</span>
          </div>
        </td>
      </tr>
      <tr>
        <td style="vertical-align: middle; border-color: rgb(204, 204, 204);">
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">８</span></div>
        </td>
        <td style="vertical-align: middle; border-color: rgb(204, 204, 204);">
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">複数のPCでシステムを利用できるか</span></div>
        </td>
        <td style="border-color: rgb(204, 204, 204);">
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">販売媒体との接続（ログイン設定ファイルの取得）に関しましては１つのPCからのみしか設定できません。</span></div>
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">それ以外の操作、例えば、商品の価格設定や出品登録等は複数のPCから設定していただいても問題ありません。</span></div>
        </td>
      </tr>
      <tr>
        <td style="vertical-align: middle; border-color: rgb(204, 204, 204);">
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">９</span></div>
        </td>
        <td style="vertical-align: middle; border-color: rgb(204, 204, 204);">
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">卸サイトからの連携ができない</span></div>
        </td>
        <td style="border-color: rgb(204, 204, 204);">
          <div><span style="font-size: 12px;"><a href="https://www.evernote.com/shard/s740/sh/ad4b4699-b63d-3fe3-fce6-7fbe3b760483/8cfb999600ea6e7446488d38750fc14f" rel="noopener noreferrer" rev="en_rl_none" style="font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold; font-size: 12px;">卸サイトと自動販売システムの連携について</a></span></div>
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">こちらの注意点等を参考にしても上手く連携できない場合は、お問い合わせいただけますでしょうか。システムの不具合の可能性がありますので原因を調査致します。</span></div>
        </td>
      </tr>
      <tr>
        <td style="vertical-align: middle; border-color: rgb(204, 204, 204);">
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">１０</span></div>
        </td>
        <td style="vertical-align: middle; border-color: rgb(204, 204, 204);">
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">チャットワーク通知設定とは</span></div>
        </td>
        <td style="border-color: rgb(204, 204, 204);">
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">販売媒体で商品が購入された際にチャットワークの通知で知ることができます。</span></div>
          <div><span style="font-size: 12px;"><a href="https://www.youtube.com/watch?v=HaDdexBPoM4" rev="en_rl_none" style="font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold; font-size: 12px;">https://www.youtube.com/watch?v=HaDdexBPoM4</a></span></div>
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">※動画内ではコメントがあった場合も通知がくると説明がありますが、現在は廃止されております。商品の購入のみ通知がくるようになっております。</span></div>
        </td>
      </tr>
      <tr>
        <td style="border-color: rgb(204, 204, 204);">
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">１１</span></div>
        </td>
        <td style="border-color: rgb(204, 204, 204);">
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">解約される場合</span></div>
        </td>
        <td style="border-color: rgb(204, 204, 204);">
          <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">以下からお願い致します。</span></div>
          <div><span style="font-size: 12px;"><a href="https://docs.google.com/forms/d/e/1FAIpQLSejEgPSmpn1_cZIHnnyhsFSQ9AG7N5q5NEcyu_X_jJoJRSRWg/viewform?usp=sf_link" rev="en_rl_none" style="font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold; font-size: 12px;">https://docs.google.com/forms/d/e/1FAIpQLSejEgPSmpn1_cZIHnnyhsFSQ9AG7N5q5NEcyu_X_jJoJRSRWg/viewform?usp=sf_link</a></span></div>
        </td>
      </tr>
      <tr>
            <td style="vertical-align: middle; border-color: rgb(204, 204, 204);">
              <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">１２</span></div>
            </td>
            <td style="vertical-align: middle; border-color: rgb(204, 204, 204);">
              <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">「出品登録一覧」から解除した商品は値引きされるか</span></div>
            </td>
            <td style="border-color: rgb(204, 204, 204);">
              <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">値引の設定がされている商品でも値引はされません。</span></div>
              <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">値引はあくまで出品登録されている商品が対象です。</span></div>
            </td>
          </tr>
          <tr>
            <td style="vertical-align: middle; border-color: rgb(204, 204, 204);">
              <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">１３</span></div>
            </td>
            <td style="vertical-align: middle; border-color: rgb(204, 204, 204);">
              <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">「出品登録一覧」から解除した商品は公開停止、出品削除されるか</span></div>
            </td>
            <td style="border-color: rgb(204, 204, 204);">
              <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">出品停止の設定がされている商品でも公開停止、出品削除はされません。</span></div>
              <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">公開停止、出品削除はあくまで出品登録されている商品が対象です。</span></div>
            </td>
          </tr>
          <tr>
            <td style="vertical-align: middle; border-color: rgb(204, 204, 204);">
              <div><span style="font-size: 14px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">１４</span></div>
            </td>
            <td style="vertical-align: middle; border-color: rgb(204, 204, 204);">
              <div><span style="font-size: 14px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">「出品登録一覧」から解除した商品が購入された場合の在庫数はどうなるか</span></div>
            </td>
            <td style="border-color: rgb(204, 204, 204);">
              <div><span style="font-size: 14px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">出品登録されていない商品でも商品が購入された場合は在庫数はカウントダウンされます。</span></div>
            </td>
          </tr>
          <tr>
            <td style="vertical-align: middle; border-color: rgb(204, 204, 204);">
              <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">１５</span></div>
            </td>
            <td style="vertical-align: middle; border-color: rgb(204, 204, 204);">
              <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">商品が購入されて、在庫数が０になった商品を手動で先に「出品登録一覧」から解除した場合どうなるか</span></div>
            </td>
            <td style="border-color: rgb(204, 204, 204);">
              <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">在庫数０の商品に対しては、出品登録がされていない商品でも公開停止、出品削除されます。</span></div>
            </td>
          </tr>
          <tr>
            <td style="vertical-align: middle; border-color: rgb(204, 204, 204);">
              <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">１６</span></div>
            </td>
            <td style="vertical-align: middle; border-color: rgb(204, 204, 204);">
              <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">在庫数が０であるが公開停止、出品削除がされていない</span></div>
            </td>
            <td style="border-color: rgb(204, 204, 204);">
              <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">在庫数０の商品に対する公開停止、出品削除の処理はタイムラグがあります。</span></div>
              <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">タイミングによっては翌日になることもあります。</span></div>
              <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">在庫数が０になっている商品が新たに出品されることはありません。</span></div>
              <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">既に出品されてしまっている商品に対しては原則手動で公開停止or削除を行ってください。</span></div>
              <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">手動での作業に漏れがあった場合でもシステムが公開停止、出品削除をする補助機能とお考えください。</span></div>
            </td>
          </tr>
          <tr>
            <td style="vertical-align: middle; border-color: rgb(204, 204, 204);">
              <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">１７</span></div>
            </td>
            <td style="vertical-align: middle; border-color: rgb(204, 204, 204);">
              <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">ヤフオクのみ出品がされていない</span></div>
            </td>
            <td style="border-color: rgb(204, 204, 204);">
              <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">①ヤフオクの設定で出品ページの下部にある「出品者情報の登録」と「Yahoo!ウォレットの登録」はできているかご確認いただけますでしょうか。</span></div>
              <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">→ヤフオク出品の必須項目です。</span></div>
              <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">②商品登録のヤフー独自設定の「終了する日時」を「出品から１日後」に設定できていますでしょうか？</span></div>
              <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">→動画でも「出品から１日後」に設定でご説明しております。１日後以上にすると出品商品のタイトルが被る可能性が出るので出品できないタイミングが発生します。</span></div>
              <div><span style="font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold; font-size: 12px;">上記２点が正しく設定されている</span><span style="font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold; font-size: 12px; color: rgb(36, 36, 36);">場合は、</span><span style="font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold; font-size: 12px;">お問い合わせいただけますでしょうか。システムの不具合の可能性がありますので原因を調査致します。</span></div>
            </td>
          </tr>
          <tr>
            <td style="border-color: rgb(204, 204, 204);">
              <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">１８</span></div>
            </td>
            <td style="border-color: rgb(204, 204, 204);">
              <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">paypayフリマが出品できていない</span></div>
            </td>
            <td style="border-color: rgb(204, 204, 204);">
              <div><span style="font-size: 12px; font-family: &quot;Source Code Pro&quot;, monospace; font-weight: bold;">paypayフリマはヤフオクからの連携出品ですのでアプリ上に出品商品は表示されません。</span></div>
            </td>
          </tr>
    </tbody>
  </table>
</div> -->

<div class="login">
    
    <div class="login_form_top">
        <h1 class="title">お問い合わせ</h1>
    </div>
    <div class="formBox">
        <h2 class="itemLabel">チャットワーク名</h2>
        <div class='validErrMsg' v-for="(err) in $v.name.errMsg" :key="err">{{ err }}</div>
        <input type="text" v-model="name" @input="valid($v.name, 'チャットワーク名')">
        <!-- <h2 class="itemLabel">メールアドレス</h2>
        <div class='validErrMsg' v-for="(err) in $v.mail.errMsg" :key="err">{{ err }}</div>
        <input type="text" v-model="mail" @input="valid($v.mail, 'メールアドレス')" > -->
        <h2 class="itemLabel">お問い合わせ内容</h2>
        <div class='validErrMsg' v-for="(err) in $v.inquiry.errMsg" :key="err">{{ err }}</div>
        <textarea v-model="inquiry" @input="valid($v.inquiry, 'お問い合わせ内容')" ></textarea>
        <input type="text" class="none" v-model="tmp">
        <button class="btn" @click="sbmit">お問い合わせ</button>
    
    </div>
</div>

</div>

</template>
<script>
import {inquiryRepository} from '@/Repositories/inquiryRepository.js'
import { required} from "vuelidate/lib/validators";
import check from '@/common/commonCheck';
export default {
    data() {
        return {
            name:'',
            // mail:'',
            inquiry:'',
            tmp:''
        }
    },
    methods:{
        sbmit(){
            let vm = this;
            if(!vm.validAll()) return;

            var postItem = {
                name: vm.name,
                // mail:vm.mail,
                inquiry:vm.inquiry
            }
            inquiryRepository.methods.inquiry(postItem)
            .then(res=>{
                this.$swal("送信しました", {
                        icon: "success",
                    });
                vm.name = '';
                vm.inquiry = '';
            }).catch(()=>{;});
        },
        valid(v, name, regexType){
            check.checkStr(v, name, regexType);
        },
        validAll(){
            let vm = this;
            try{
                if(!check.checkStr(vm.$v.name, 'お名前'))  throw 'name';
                // if(!check.checkStr(vm.$v.mail, 'メールアドレス')) throw 'mail';
                if(!check.checkStr(vm.$v.inquiry, 'お問い合わせ内容')) throw 'inquiry';
            }catch(e){
                vm.tmp = 'tmp';
                return false;
            }
            return true;
        },
    },
    created(){
        ;
    },
    validations: {
        name:{
            required
        },
        mail:{
            required,
            err:(val)=> check.MailAddress(val)
        },
        inquiry:{
            required
        }
    }
}
</script>
<style scoped lang="scss">
@import "../style/login.scss";
.container{
height: 300px;
    overflow: scroll;
    margin: 7% auto;
}
.inquiryTable{
    
    td{
        border: solid 1px;
    }
}
</style>